import script from "./AffiliateLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateLayout.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateLayout.vue?vue&type=style&index=0&id=23fe0c31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fe0c31"]])

export default __exports__